import { handledGetFetch, handledPostFetch } from '../../submodules/shared/utils/api-base';

import { PATHS } from './paths';
import { buildUrl } from './url';

export const getUserCache = () => handledGetFetch(buildUrl(PATHS.userCache));

export const postUserCache = (payload) => handledPostFetch(buildUrl(PATHS.userCacheById(payload.account_id)), payload);
